import { RouteObject } from "react-router-dom";
import { MAIN_ROUTES } from "../Common/Constants";
import { MainLayout } from "../Layout/MainLayout";
import { Home } from "../Containers/Home";
import ErrorBoundary from "Common/Components/ErrorBoundary";

export const MAIN_ROUTER_CONFIG: RouteObject[] = [
  {
    path: MAIN_ROUTES.ROOT,
    element: (
      <ErrorBoundary>
        <MainLayout />
      </ErrorBoundary>
    ),
    children: [
      {
        path: MAIN_ROUTES.ROOT,
        element: <Home />,
        children: [
          {
            path: "",
            async lazy() {
              const { ChatWindow } = await import("../Containers/Home");
              return {
                Component: () => <ChatWindow isInitial={true} />,
              };
            },
          },
          {
            path: `/c/:${MAIN_ROUTES.CHAT_ID}`,
            async lazy() {
              const { ChatWindow } = await import("../Containers/Home");
              return {
                Component: () => <ChatWindow isInitial={false} />,
              };
            },
          },
        ],
      },
    ],
  },
];
